export default {
  cancel: '取消',
  circle_config: '圆形配置',
  confirm: '确认',
  confirm_delete: '您确定要删除此特性吗？此操作无法撤回。',
  create: '创建',
  delete_geometry: '删除几何',
  delete_vertex: '移除顶点',
  document_upload_failed: '文档上传失败。',
  draw_circle: '从中心绘制圆',
  draw_circle_2pt: '手动圆',
  draw_dialog_begin_drawing: '开始绘图 - 在地图上点击任意位置',
  draw_dialog_cancel_drawing: '取消绘图 - 按 ESC 键',
  draw_dialog_remove_vertex: '移除最后一个顶点 - 右键点击',
  draw_dialog_save: '保存 - 双击',
  draw_dialog_save_single: '保存 - 单击',
  draw_dialog_title: '绘图说明',
  draw_line: '线',
  draw_point: '点',
  draw_polygon: '多边形',
  draw_position: '当前位置',
  draw_rectangle: '矩形',
  edit_dialog_cancel_drawing: '取消绘图 - 单击取消按钮以取消绘图。',
  edit_dialog_modify_shape:
    '编辑形状 - 拖动顶点以修改形状，或在多边形上添加新顶点。',
  edit_dialog_remove_vertex: '移除顶点 - 单击顶点以将其移除。',
  edit_dialog_save: '保存 - 单击保存按钮以保存您的更改。',
  edit_dialog_title: '编辑说明',
  filter_searchbox_placeholder: '搜索',
  icon_scaling_cluster: '聚类图标缩放',
  icon_scaling_cluster_log: '聚类对数缩放',
  icon_scaling_field: '切换字段图标缩放',
  icon_scaling_label: '图标缩放',
  icon_scaling_zoom_in: '放大缩放',
  icon_scaling_zoom_out: '缩小缩放',
  identical_values_filter: '此字段仅包含一个不同的值，无法进行过滤。',
  image_upload_failed: '图片上传失败。',
  information: '信息',
  invalid_geometry: '无效的几何图形',
  invalid_lat_lon: '提供的坐标不在所选区域内。',
  invalid_lat_long_range: '无效的坐标：纬度和经度值必须在有效范围内。',
  layer_add_new_location: '添加新位置',
  layer_dataview_header: '数据视图',
  layer_filter_clear_all: '清除所有过滤器',
  layer_filter_dropdown_select: '选择多个',
  layer_filter_greater_than: '大于',
  layer_filter_header: '过滤器',
  layer_filter_less_than: '小于',
  layer_filter_reset_all: '重置所有过滤器',
  layer_filter_select: '从列表中选择过滤器',
  layer_filter_set_filter: '设置过滤器',
  layer_grid_legend_ratio: '将颜色显示为与大小的比率',
  layer_group_hide_layers: '隐藏组中的所有层',
  layer_style_cluster: '多个位置',
  layer_style_display_hover: '启用悬停',
  layer_style_display_labels: '显示标签',
  layer_style_header: '样式',
  layer_style_opacity: '更改图层不透明度：',
  layer_style_select_theme: '选择主题样式',
  layer_style_switch_all: '切换所有',
  layer_style_switch_caption: '单击标签以切换可见性或',
  layer_visibility: '切换可见性',
  layer_zoom_to_extent: '缩放到过滤层的范围',
  layers: '层',
  link: '链接',
  loading: '加载中',
  location_clear_all: '清除所有位置',
  location_close_without_save: '在不保存更改的情况下关闭位置？',
  location_delete: '删除位置',
  location_listview_full: '位置列表视图已满。',
  location_remove: '从选择中移除特性',
  location_save: '将更改保存到云端',
  location_save_changes: '您确定要保存对此位置的更改吗？',
  location_zoom: '将地图缩放到特性边界',
  locations: '位置',
  modify_geometry: '修改几何',
  no_data_filter: '此字段不包含数据，无法进行过滤。',
  no_layers: '在区域内没有可访问的图层。',
  no_locales:
    '您的帐户已被验证和批准，但您没有访问任何区域的权限。这可能是因为管理员没有给您所需的角色。请联系管理员以解决此问题。',
  no_options_available: '没有可用选项。',
  no_results: '没有找到此搜索的结果',
  ok: '确定',
  pill_component_remove: '移除',
  pin: '钉住',
  radius: '半径',
  remove_document_confirm: '您确定要移除此文档吗？此操作无法撤回。',
  remove_image_confirm: '您确定要移除此图片吗？此操作无法撤回。',
  remove_item_confirm: '移除项目？',
  remove_last_vertex: '移除最后一个顶点',
  report: '报告',
  save: '保存',
  toolbar_admin: '打开账户管理视图',
  toolbar_current_location: '当前位置',
  toolbar_fullscreen: '全屏地图视图',
  toolbar_login: '登录',
  toolbar_logout: '登出',
  toolbar_zoom_in: '放大',
  toolbar_zoom_out: '缩小',
  toolbar_zoom_to_area: '缩放到区域',
  units: '单位',
  zoom_to: '缩放到',
};
